/**
 * p-c.js — make the product-card (p-c) quick-add work with UpCart.
 *
 * The card's size chips are per-variant `<button type="submit" name="id" value="…">`. UpCart intercepts
 * the form submit and reads the form's fields — NOT the clicked submit button — so the variant id never
 * reaches it (it opens the drawer but adds nothing). Fix: on chip click, copy the clicked variant into a
 * hidden `input[name="id"]` before the native submit runs, so UpCart adds the correct variant.
 *
 * Delegated on document → works for cards in the grid AND cards cloned into the lookbook drawer.
 * No-JS / no-UpCart: the native submit still carries the button's id, so add-to-cart still works.
 */
(function () {
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.p-c__chip[type="submit"][name="id"]');
    if (!chip) return;

    var form = chip.closest('form');
    if (!form) return;

    var idInput = form.querySelector('input[type="hidden"][name="id"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      form.appendChild(idInput);
    }
    idInput.value = chip.value;
    // Native submit proceeds → UpCart reads input[name="id"] → adds the correct variant + opens.
  });
})();
